import script from "./HLCArea.vue?vue&type=script&lang=js"
export * from "./HLCArea.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__